import { render, staticRenderFns } from "./select-cmp-extended.vue?vue&type=template&id=1143bfc2&scoped=true"
import script from "./select-cmp-extended.vue?vue&type=script&lang=js"
export * from "./select-cmp-extended.vue?vue&type=script&lang=js"
import style0 from "./select-cmp-extended.vue?vue&type=style&index=0&id=1143bfc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1143bfc2",
  null
  
)

export default component.exports